// import * as apis from '@apis'

const orgWorkload = {
  namespaced: true,
  state: {
    column: {},
    time: [],
    ch: {},
    org: '',
    user: ''
  },
  getters: {},
  mutations: {
  },
  actions: {
    setColumn ({state}, column) {
      state.column = column
    },
    setTime ({state}, time) {
      state.time = time
    },
    setOrg ({state}, column) {
      state.org = column
    },
    setUser ({state}, time) {
      state.user = time
    },
    setCh ({state}, ch) {
      if (typeof ch === 'object') state.ch = ch
    }
  }
}

export default orgWorkload
